export default "/packs/images/banner-arrow~45a72a5c0cf55d9e05bdea3805fdb429.png";